export default "__VITE_ASSET__C5Qq7gl___"